import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VisiteService {

  constructor(
    private http: HttpClient
  ) { }

  getVisitaDetails(lingua, cantina, tipovisita): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/details/' + lingua + '/' + cantina + '/' + tipovisita + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getVisitaRegaloDetails(lingua, cantina, tipovisita): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/regalo-details/' + lingua + '/' + cantina + '/' + tipovisita + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getOpzioniExtra(lang, idTipoVisita): Observable<any[]> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/visite/opzioniextra/' + lang + '/' + idTipoVisita + '/'
    ).pipe(map(response => {
      return response;
    }));
  }

  getOpzioniGite(lang, idTipoVisita): Observable<any[]> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/visite/opzionigite/' + lang + '/' + idTipoVisita + '/'
    ).pipe(map(response => {
      return response;
    }));
  }

  getRichiesteParticolari(codiceForm, lingua): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + 'public/cantine/richieste-particolari/' + codiceForm + '/' + lingua + '/')
      .pipe(map(response => {
        return response;
      }));
  }
}
